import { render } from "./DocumentTagWrapper.vue?vue&type=template&id=b570b9b2"
import script from "./DocumentTagWrapper.vue?vue&type=script&lang=js"
export * from "./DocumentTagWrapper.vue?vue&type=script&lang=js"

import "./DocumentTagWrapper.vue?vue&type=style&index=0&id=b570b9b2&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__